import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="about" className="py-20 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-4">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <div className="inline-flex items-center px-4 py-2 mb-4 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 text-sm font-medium">
            AI • Automation • Full‑Stack
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight pb-1 bg-clip-text text-transparent bg-gradient-to-r from-blue-700 to-purple-600">
            Turning Complex Challenges Into Intelligent Solutions
          </h2>
          <div className="space-y-6 text-lg text-gray-600">
            <p>
              Software & AI Engineer — automation, intelligent data extraction (documents/web), and production‑ready full‑stack products.
            </p>
            <p>
              I build AI infrastructure that turns data into decisions and deploy automation workflows at scale. Founder of
              {' '}
              <a
                href="https://tonexora.com"
                target="_blank"
                rel="noreferrer"
                className="text-blue-600 dark:text-blue-400 underline"
              >
                tonexora.com
              </a>
              {' '}— after leading projects across multiple companies and campaigns, I’m now bringing this expertise to Upwork.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
            {[
              { label: 'Projects', value: '50+' },
              { label: 'Clients', value: '30+' },
              { label: 'Automation Flows', value: '37+' },
              { label: 'Uptime', value: '99.9%' },
            ].map((stat, idx) => (
              <div key={idx} className="rounded-2xl border border-gray-200 dark:border-gray-700 p-4 bg-white/70 dark:bg-gray-800/70 backdrop-blur neo-surface">
                <div className="text-2xl font-bold text-gray-900 dark:text-white">{stat.value}</div>
                <div className="text-sm text-gray-600 dark:text-gray-300">{stat.label}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About; 